import { ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Center, Grid, Heading, Image, Text } from "@chakra-ui/react";
import { Data } from "../Context/DataContext";
import { useContext } from "react";
import { Link } from "react-router-dom";

export default function ShopByCategory() {
    const { handleCategory } = useContext(Data);
    const showByCategory = [
        {
            
            id: 1,
            title: 'Generic Products'
        },
        // /generics, specialities, otc, patemt,surgicals/
        {
            id: 2,
            title: 'OTC Products'
        },
        {
            id: 3,
            title: 'Patent Products'
        },
        {
            id: 4,
            title: 'Specialities'
        },
        {
            id: 5,
            title: 'Surgical Itmes'
        }
    ]
  return (
    <Box p='0 25px' mb='30px'>
        <Box display={'flex'} alignItems='center' justifyContent='space-between' mb='30px'>
            <Box>
            <Heading as='h2' fontSize='25px' fontWeight='500'>Shop By Category</Heading>
            </Box>
            {/* <Box>
                <Link color='red' style={{textDecoration: 'none'}} ><Text>View All <ChevronRightIcon/></Text></Link>
            </Box> */}
        </Box>
        <Grid overflow={{base: 'scroll', md: 'hidden'}} pb='20px' templateColumns={`repeat(${showByCategory.length},1fr)`} gap={3}>
            {
                showByCategory.map(((el, index) => (
                    <Link to="/products" onClick={() => handleCategory(el.title)}>
                        <Box w={{base: '200px', md: '18vw'}} key={el.id} bg='#fff' p='30px 20px' borderRadius={6} boxShadow='md' cursor='pointer'>
                            <Center><Image  h={'150px'}  objectFit="cover" margin={"0 auto"}src={process.env.PUBLIC_URL+`/Images/UDYOGSBC${index+1}.jpg`}></Image></Center>
                            <Center><Text mt='20px' fontWeight={'600'}>{el.title}</Text></Center>
                            
                        </Box>
                    </Link>
                )))
            }
        </Grid>
    </Box>
  )
}
